<script lang="ts" module>
  import { TeoCore } from '@/teoCore/TeoCore';
  import { useIsCurrentTextSet } from '@/teoCore/text/hooks/use-is-current-text-set';
  import type { TeoText } from '@/teoCore/text/TeoText';
  import ContentCard, { type ContentCardProps } from '@/ui/elements/card/ContentCard.svelte';

  import TaskMaster from './cmps/TaskMaster.svelte';

  export interface AdditionalProps {
    text: TeoText;
  }

  type InitCardProps = AdditionalProps & ContentCardProps;
</script>

<script lang="ts">
  let { text, ...props }: InitCardProps = $props();
  let dynamicConfigStore = TeoCore.current.dynamicConfig;
  let isCurrentTextSet = useIsCurrentTextSet();

  let TS = $derived(text.store);
</script>

<ContentCard {...props}>
  {#if $dynamicConfigStore.textGeneratorEnabled}
    <TaskMaster taskLabel="Wähle eine Analyse-Konfiguration" done={$TS.allPromptOptionsSelected}
    ></TaskMaster>
    <TaskMaster taskLabel="Füge deinen Text ein" done={isCurrentTextSet.current}></TaskMaster>
  {:else}
    <TaskMaster taskLabel="Füge deinen Text ein" done={isCurrentTextSet.current}></TaskMaster>
    <TaskMaster taskLabel="Wähle eine Analyse-Konfiguration" done={$TS.allPromptOptionsSelected}
    ></TaskMaster>
  {/if}
</ContentCard>
